<template>
    <div class="vue-partspoint-finder partspoint-finder" :class="{'is-homepage': isHomePage, 'map-active': isMobile && showMap, 'list-active': isMobile && !showMap }">
        <div class="finder-wrapper">
            <div class="search-bar-wrapper">
                <div class="row">
                    <div class="search-bar col-12 col-md-6 col-xl-5">
                        <div class="inner">
                            <h1 class="virtual-h2 mb-3 title" v-if="!isHomePage">
                                {{ title }}
                            </h1>

                            <h2 class="mb-3 title" v-if="isHomePage">
                                {{ title }}
                            </h2>

                            <div class="finder-search-input">
                                <div class="input-group finder-input">
                                    <gmap-autocomplete
                                        slotRefName="gmapAutocomplete"
                                        :select-first-on-enter="true"
                                        :options="autocompleteOptions"
                                        @focus="loadMap"
                                        @place_changed="setPlace">
                                        <input ref="gmapAutocomplete" :placeholder="placeholderText" class="pac-target-input vue-gmap-autocomplete form-control">
                                    </gmap-autocomplete>

                                    <button
                                        v-if="showResetButton"
                                        @click="handleReset"
                                        class="reset-map"
                                    ><span class="visually-hidden">Reset map</span></button>
                                </div>
                            </div>

                            <template v-if="isMobile">
                                <ul class="mobile-toggle">
                                    <li><button :class="{'active': !showMap}" @click="showMap = false">{{ listShowText }}</button></li>
                                    <li><button :class="{'active': showMap}" @click="showMap = true">{{ mapShowText }}</button></li>
                                </ul>
                            </template>

                            <template v-if="hasMarkers && !loading">
                                <perfect-scrollbar>
                                    <div class="marker-meta">
                                        <p>{{ markersLength }} {{ branchesText }} <template v-if="hasPlace">{{ nearYouText }}</template></p>
                                    </div>

                                    <div class="results-wrapper" v-if="showList">
                                        <pp-marker-mini-card
                                            v-for="(marker, index) in computedMarkers"
                                            :key="index"
                                            :marker="marker"
                                            :event-bus="eventBus"
                                            :is-home-page="isHomePage"
                                            @marker-clicked="handleMarkerClicked"
                                        ></pp-marker-mini-card>
                                    </div>
                                </perfect-scrollbar>
                            </template>

                            <template v-if="loading">
                                <div class="loader"><span class="visually-hidden">loading..</span></div>
                            </template>

                            <transition name="fade" v-if="!isMobile">
                                <pp-active-marker
                                    v-if="hasActiveMarker"
                                    :marker="activeMarker"
                                    :event-bus="eventBus"
                                ></pp-active-marker>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="doMapLoad === true">
                <div class="store-locator" v-show="showMap">
                    <gmap-map
                        :center="center"
                        ref="mapRef"
                        :zoom="mapZoom"
                        map-type-id="roadmap"
                        :options="mapOptions"
                        @zoom_changed="mapZoom = $event"
                    >
                        <gmap-cluster :options="clusterOptions">
                            <gmap-marker
                                :key="index"
                                :icon="activeMarker?.id === marker.id ? activeImageMarker : imageMarker"
                                v-for="(marker, index) in mappedMarkers"
                                :position="marker.location"
                                :clickable="true"
                                @click="handleMarkerClicked(marker)"
                            />
                        </gmap-cluster>
                    </gmap-map>
                </div>
            </template>

            <pp-google-inside-wrapper
                :event-bus="eventBus"
            ></pp-google-inside-wrapper>

            <transition name="fade" v-if="isMobile">
                <pp-active-marker
                    v-if="hasActiveMarker"
                    :marker="activeMarker"
                    :event-bus="eventBus"
                ></pp-active-marker>
            </transition>
        </div>

        <div class="section-body-text" v-if="hasActiveMarker && isHomePage === false">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8" v-html="activeMarker.body"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mixin as focusMixin} from './../../../../../themes/custom/ef2_custom/node_modules/vue-focus';
import {
    SuperClusterAlgorithm
} from './../../../../../themes/custom/ef2_custom/node_modules/@googlemaps/markerclusterer';
import mapSettings from '../constants/map'
import MarkerWrapper from '../../../../../modules/custom/partspoint_base/js/components/MarkerWrapper';
import MapSidebar from '../../../../../modules/custom/partspoint_base/js/components/MapSidebar';
import GoogleInsideWrapper from '../../../../../modules/custom/partspoint_base/js/components/GoogleInsideWrapper';
import MarkerMiniCard from "./MarkerMiniCard";
import ActiveMarker from "./ActiveMarker";

export default {
    name: "PartsPointFinder",

    mixins: [focusMixin],

    components: {
        'pp-marker-wrapper': MarkerWrapper,
        'pp-map-sidebar': MapSidebar,
        'pp-google-inside-wrapper': GoogleInsideWrapper,
        'pp-marker-mini-card': MarkerMiniCard,
        'pp-active-marker': ActiveMarker,
    },

    props: {
        bundle: {
            type: String,
            default: ""
        },
        activeGarageId: {
            type: String,
            default: ""
        },
        language: {
            type: String,
            default: "nl"
        }
    },

    data() {
        return {
            imageMarker: {},
            activeImageMarker: {},
            eventBus: new Vue(),
            markers: [],
            doMapLoad: false,
            showMap: true,

            title: window.Drupal.t('Find a branch'),
            placeholderText: window.Drupal.t('Search by city or zip code'),
            listShowText: window.Drupal.t('list view'),
            mapShowText: window.Drupal.t('map view'),
            branchesText: window.Drupal.t('branches'),
            nearYouText: window.Drupal.t('close to you'),

            clusterSvg: window.btoa(`<svg fill="#f5f5f5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240"> <circle cx="120" cy="120" opacity=".6" r="70" /> <circle cx="120" cy="120" opacity=".3" r="90" /><circle cx="120" cy="120" opacity=".2" r="110" /></svg>`),
            activeMarkerId: null,

            center: mapSettings.center,
            mapZoom: mapSettings.mapZoom,
            mapOptions: mapSettings.mapOptions,

            place: null,

            autocompleteOptions: {
                types: ['geocode'],
                componentRestrictions: {
                    country: ['be']
                }
            },

            filteredMarkers: {},
            gmapInputValue: '',
            loading: false,
        }
    },

    mounted() {
        this.checkDevice();
        this.fetchData();
        setTimeout(() => this.doMapLoad = true, 1000);
        this.eventBus.$on('remove-active-marker', () => this.handleRemoveActiveMarker());
    },

    computed: {
        device() {
            return this.$mq;
        },

        isMobile() {
            return this.device === 'mobile';
        },

        showList() {
            if (!this.isMobile) {
                return true;
            }

            return !this.showMap;
        },

        hasActiveMarker() {
            return !_.isEmpty(this.activeMarker);
        },

        activeMarker() {
            return _.find(this.mappedMarkers, (marker) => {
                return marker.id === this.activeMarkerId;
            })
        },

        isHomePage() {
            return _.isEqual(this.bundle, 'homepage');
        },

        hasMarkers() {
            return ! _.isEmpty(this.markers)
        },

        hasPlace() {
            return ! _.isNil(this.place);
        },

        markersLength() {
            return Object.keys(this.computedMarkers).length;
        },

        showFilteredMarkers() {
            return !_.isEmpty(this.filteredMarkers) && this.hasPlace && !this.loading;
        },

        noFilteredMarkersResult() {
            return _.isEmpty(this.filteredMarkers) && !_.isEmpty(this.gmapInputValue) && !this.loading;
        },

        showResetButton() {
            return ! _.isEmpty(this.gmapInputValue) && !this.loading;
        },

        computedMarkers() {
            if (this.showFilteredMarkers) {
                return this.filteredMarkers;
            }

            return this.markers;
        },

        mappedMarkers() {
            return this.markers.map((marker) => {
                return {
                    ...marker,
                    location: new google.maps.LatLng({
                        lat: parseFloat(marker.geoLocation.lat),
                        lng: parseFloat(marker.geoLocation.lng)
                    })
                }
            })
        },

        clusterOptions() {
            return {
                renderer: {
                    render: ({ count, position }) =>
                        new google.maps.Marker({
                            label: { text: String(count), color: "black", fontSize: "14px", fontWeight: "bold" },
                            icon: {
                                url: `data:image/svg+xml;base64,${this.clusterSvg}`,
                                scaledSize: new google.maps.Size(45, 45),
                            },
                            position,
                            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                        }),
                },
                algorithm: new SuperClusterAlgorithm({radius: 125}),
            };
        },
    },

    methods: {
        fetchData(fromPlace = false) {
            this.loading = true;
            let url = `/${this.language}/api/garages`;

            if (this.language === 'nl') {
                url = `/api/garages`;
            }

            if (fromPlace) {
                url = url.concat(`?lat=${this.place.geometry.location.lat()}&lng=${this.place.geometry.location.lng()}`);
            }

            axios.get(url)
                .then(response => {
                    if (!fromPlace) {
                        this.markers = response.data;
                        return;
                    }

                    this.filteredMarkers = response.data;
                })
                .catch(error => {
                    this.markers = {};
                    this.filteredMarkers = {};
                })
                .finally(() => {
                    if (!fromPlace) {
                        this.checkActiveGarageId();
                    }

                    this.imageMarker = {
                        scaledSize: new google.maps.Size(40, 37),
                        url: '/themes/custom/ef2_custom/images/marker.svg'
                    }

                    this.activeImageMarker = {
                        scaledSize: new google.maps.Size(65, 60),
                        url: '/themes/custom/ef2_custom/images/marker.svg'
                    }
                    this.loading = false;
                });
        },

        loadMap() {
            setTimeout(this.doMapLoad = true, 500);
        },

        setPlace(place) {
            if (_.isEmpty(place.name)) {
                this.handleReset();
                return;
            }

            this.place = place;
            this.goToPlace();
            this.gmapInputValue = this.$refs.gmapAutocomplete.value;
            this.fetchData(true);
        },

        checkBundleType() {
            if (this.bundle !== "garages_overview") {
                this.doMapLoad = false;
                return;
            }

            this.doMapLoad = true;
        },

        goToPlace() {
            if (!this.place || _.isNil(this.place.geometry)) {
                // this.$toaster.error('Er is geen locatie gevonden. ')
                return;
            }

            this.center = {
                lat: this.place.geometry.location.lat(),
                lng: this.place.geometry.location.lng(),
            };

            this.mapZoom = 11;
        },

        geoLocate() {
            navigator.geolocation.getCurrentPosition(position => {
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                this.mapZoom = 11;

                // Mag uit voor prod
                // this.$toaster.success('Locatie succesvol opgehaald!')
            });
        },

        handleMarkerClicked(marker) {
            if (this.activeMarkerId === marker.id) {
                return this.handleRemoveActiveMarker();
            }

            this.handleMarkerPanTo(marker.geoLocation);
            this.handleActiveMarker(marker);
        },

        handleMarkerPanTo(payload) {
            this.mapZoom = this.$refs.mapRef.zoom > 11 ? this.$refs.mapRef.zoom : 11;
            this.$refs.mapRef.panTo({lat: parseFloat(payload.lat), lng: parseFloat(payload.lng)})
        },

        handleActiveMarker(payload) {
            if (_.isEmpty(payload)) {
                this.mapZoom = 8;
                this.$refs.mapRef.panTo(this.center);
            }

            this.activeMarkerId = payload.id;
        },

        handleRemoveActiveMarker() {
            this.activeMarkerId = null;
            let zoom = 8;

            if (!_.isEmpty(this.gmapInputValue)) {
                zoom = 11;
            }

            this.mapZoom = zoom;
            this.$refs.mapRef.panTo(this.center);
            this.changePageMeta();
        },

        checkActiveGarageId() {
            let initialActiveMarker = _.find(this.markers, (marker) => {
                return marker.id === parseFloat(this.activeGarageId);
            });

            if (_.isNil(initialActiveMarker)) {
                return;
            }

            this.activeMarkerId = initialActiveMarker.id;

            setTimeout(() => {
                this.mapZoom = 11;
                this.$refs.mapRef.panTo({
                    lat: parseFloat(this.activeMarker.geoLocation.lat),
                    lng: parseFloat(this.activeMarker.geoLocation.lng)
                })
            }, 1000);
        },

        changePageMeta() {
            if (this.isHomePage) {
                return;
            }

            let newPageTitle = 'Vestigingen | PartsPoint';
            document.title = newPageTitle;
            window.history.pushState({}, newPageTitle, window.location.origin + '/vestigingen');
        },

        handleReset() {
            this.filteredMarkers = {};
            this.place = null;
            this.gmapInputValue = '';
            this.$refs.gmapAutocomplete.value = '';
            this.mapZoom = 8;
            this.center = {lat: 50.688902, lng: 3.2993039};
            this.$refs.mapRef.panTo(this.center);
        },

        checkDevice() {
            if (this.device !== 'mobile') {
                return;
            }

            this.showMap = false;
        }
    }
}
</script>
